// Redux action types
export const SET = 'one-state-visittypes-athena/set';
export const REINIT = 'one-state-visittypes-athena/reinit';

